/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import AudioTriggerOrdered from '../Audio/AudioTriggerOrdered';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import Effect from './Effect';

/** @hidden */
const ccclass = cc._decorator.ccclass;
/** @hidden */
const property = cc._decorator.property;

/** An effect for reseting an order audio trigger. */
@ccclass
export default class ResetAudioTriggerOrderedEffect extends Effect
{
    /** Reference of trigger to be reset. */
    @property({ type: InjectableComponent, visible: true })
    private _audioTriggerRef: InjectableComponent<AudioTriggerOrdered> = new InjectableComponent<AudioTriggerOrdered>();

    protected setContexts(): void
    {
        this._audioTriggerRef.SetContext(AudioTriggerOrdered);
    }

    /** Resets referenced audio trigger. */
    protected trigger = (): void =>
    {
        if (this._audioTriggerRef.Value) { this._audioTriggerRef.Value.Reset(); }

        this.complete();
    }
}
